export const numberFormat = number => {
    let format = ''
    if(number){
        format = number.toString();
    }

    return format.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}